/**
 * Module dependencies.
 */

import { Description } from 'components/atoms/description/description';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div`
  padding-top: 60px;
  align-items: center;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding-top: 40px;
  }
`;

/**
 * Export `ProductsWrapper` styled component.
 */

export const ProductsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 36px 20px 20px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 36px 10px 10px;
  }
`;

/**
 * Export `DescriptionWrapper` styled component.
 */

export const DescriptionWrapper = styled.div`
  align-items: center;
  max-width: 1024px;
  padding: 0 32px;
  display: flex;
  margin: 0 auto;
  margin-top: 32px;

  @media (max-width: 768px) {
    max-width: 80vw;
  }

  @media (max-width: 576px) {
    max-width: 100vw;
    padding: 0 16px;
  }
`;

/**
 * Export `ProductsDescription` styled component.
 */

export const ProductsDescription = styled(Description)`
  text-align: center;
  max-width: 930px;
`;
